import React from 'react'

const NotFoundPage = () => (
  <div>
    <h1>NOT FOUND</h1>
    <p>指定されたページが見つかりません</p>
  </div>
)

export default NotFoundPage
